import React from 'react';
import FeatureFlag from 'components/shared/FeatureFlag';
import NotificationSubscription from 'components/NotificationSubscriptions';

const NotificationSubscriptionEvents = [
  'user-created',
  'user-updated',
  'user-archived',
  'user-restored',
];

const NotificationSubscriptionsTab = _props => {
  return (
    <>
      <FeatureFlag features="webhook">
        <div id="webhook" className="panel_body row">
          <div className="Module col-md-12">
            <h3 className="SettingsContent-heading">
              {t('settings.tab.api_webhook.event_subscription.webhook')}
            </h3>
            <hr />
            <NotificationSubscription
              meta={{
                subscriptionType: 'webhook',
                events: NotificationSubscriptionEvents,
              }}
            />
          </div>
        </div>
      </FeatureFlag>
      <br />
      <FeatureFlag features="xapi">
        <div id="xapi" className="panel_body row">
          <div className="Module col-md-12">
            <h3 className="SettingsContent-heading">
              {t('settings.tab.api_webhook.event_subscription.xapi')}
            </h3>
            <hr />
            <NotificationSubscription
              meta={{
                subscriptionType: 'xapi',
                events: null,
              }}
            />
          </div>
        </div>
      </FeatureFlag>
    </>
  );
};

export default props => <NotificationSubscriptionsTab {...props} />;
